<script setup lang="ts">
import { convertValidatorsToVuelidate } from 'frontend/_validation/rails-validators-helper'
import { computed } from 'vue'

interface Props {
  title: string
  class?: string | object | Array<string | object>
  isRequired?: boolean
  validators?: unknown
  height?: 'default' | 'small'
}
const props = withDefaults(defineProps<Props>(), {
  isRequired: false,
  height: 'default',
})

const isReallyRequired = computed(() => {
  if (!props.validators) {
    return props.isRequired
  }
  const convertedValidators = convertValidatorsToVuelidate(props.validators)
  return !!convertedValidators.required
})
</script>

<template>
  <div class="merged-input-title" :class="[props.class, { small: props.height === 'small' }]">
    <div class="title-wrapper">
      <div class="title">
        <div class="line" />
        <div class="text">
          <slot name="title">{{ props.title }}</slot>
          <span class="required" v-if="isReallyRequired"> *</span>
        </div>
      </div>
    </div>
    <slot name="default" />
  </div>
</template>

<style scoped lang="scss">
@use 'sass:map';
@use 'frontend_stylesheets/theme-variables' as themeVariables;

$defaultHeight: 48px;
$smallHeight: 34px;

:slotted(.d-flex) {
  & input {
    height: $defaultHeight;
  }
}

:slotted(.ea-select) {
  width: 100%;
}

:slotted(.input-with-icon) {
  & input:not(.vs__search) {
    height: $defaultHeight;
    //background: hsl(0 0 94%);
  }

  & .vs__dropdown-toggle {
    min-height: $defaultHeight;

    .vs__selected {
      align-self: center;
    }
  }

  .date-selector {
    width: 100%;

    & input {
      height: $defaultHeight;
      //background: hsl(0 0 94%);
      //border: 1px solid hsl(0 0% 75% / 1);
    }

    // &:focus-within input {
    //   border-color: var(--custom-primary);
    // }
  }

  .ea-select {
    width: 100%;
  }
}

:slotted(.input-wrapper) {
  & input {
    height: $defaultHeight !important;
    background: transparent;
    border: 1px solid map.get(themeVariables.$colors, outline);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 12px;

    &[disabled]:not(.preview-mode) {
      background: map.get(themeVariables.$colors, customPlatinum);
      opacity: 0.5;
    }

    .icon {
      height: $defaultHeight;
    }
  }
}

:slotted(.input-with-icon) {
  input {
    width: 100%;
  }
}

:slotted(.input-like-content) {
  height: $defaultHeight;
  border: 1px solid map.get(themeVariables.$colors, outline);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 12px;
  &[disabled]:not(.preview-mode) {
    background: map.get(themeVariables.$colors, customPlatinum);
    opacity: 0.5;
  }
}

:slotted(.form-group) {
  & input {
    height: $defaultHeight;
    //background: hsl(0 0 94%);;
    //border-color: hsl(0 0% 75% / 1);
    //border-width: 1px;
    &[disabled]:not(.preview-mode) {
      background: map.get(themeVariables.$colors, customPlatinum);
      opacity: 0.5;
    }
  }
  // &:focus-within input {
  //   border-color: var(--custom-primary);
  // }
}

:slotted(.ea-select) {
  .vs__dropdown-toggle {
    min-height: $defaultHeight;

    .vs__selected {
      align-self: center;
    }
  }
}

.merged-input-title.small {
  :slotted(.d-flex) {
    & input {
      height: $smallHeight;
    }
  }

  :slotted(.input-with-icon) {
    & input:not(.vs__search) {
      height: $smallHeight;
    }

    & .vs__dropdown-toggle {
      min-height: $smallHeight;
    }

    .date-selector {
      width: 100%;

      & input {
        height: $smallHeight;
      }
    }
  }

  :slotted(.input-wrapper) {
    & input {
      height: $smallHeight !important;
    }
  }

  :slotted(.input-like-content) {
    height: $smallHeight;
  }

  :slotted(.form-group) {
    & input {
      height: $smallHeight;
    }
  }

  :slotted(.ea-select) {
    .vs__dropdown-toggle {
      min-height: $smallHeight;
    }
  }
}

.no-border {
  :slotted(.input-with-icon) {
    .date-selector input {
      border-color: transparent !important;
    }
  }
  :slotted(.input-wrapper) {
    input {
      border-color: transparent !important;
    }
  }
  :slotted(.input-like-content) {
    border-color: transparent !important;
  }
  :slotted(.form-group) {
    & input {
      border-color: transparent !important;
    }
  }
  :slotted(.ea-select) {
    .vs__dropdown-toggle {
      border-color: transparent !important;
    }
  }
}

.merged-input-title {
  position: relative;
  padding-top: 8px;

  &.title-warning {
    .title {
      color: map.get(themeVariables.$colors, warning);
    }
  }
}

.title {
  border-radius: 5px;
  padding: 0 8px;
  font-size: 12px;
  position: relative;

  .required {
    color: map.get(themeVariables.$colors, error);
  }
}

.line {
  height: 4px;
  position: absolute;
  top: 6px;
  width: 100%;
  background: map.get(themeVariables.$colors, surface);
  z-index: 1;
  left: 0;
  border-radius: 100px;
}

.text {
  position: relative;
  z-index: 2;
}

.title-wrapper {
  position: absolute;
  top: 0;
  z-index: 1002;
  font-weight: 600;
  padding: 0 8px;
  // pointer-events: none;
  white-space: nowrap;
}
</style>
